<template>
  <div class="demand-detail-page">
    <TopBanner />

    <div class="demand-scroll-area">
      <div class="page-content">
        <!-- 面包屑 -->
        <div style="margin: 13px auto">
          <el-breadcrumb separator=">" style="font-size: 16px">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/search-result' }">搜索结果</el-breadcrumb-item>
            <el-breadcrumb-item>需求详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- 用户信息卡片 -->
        <div>
          <div style="height: 10px; background: #ff8801; border-radius: 20px 20px 0px 0px"></div>
          <div class="info-card" style="border-radius: 0px 0px 20px 20px">
            <div class="user-card">
              <div class="user-main">
                <div class="avatar">
                  <img src="@/assets/image/avatar.png" alt="avatar" />
                </div>
                <div class="user-meta">
                  <div class="name-row">
                    <span class="user-name">{{ demand?.appUser?.relationName || "无" }}</span>
                    <div class="status-tag">
                      <span class="status-valid" v-if="demand.demandStatus == 'release'">待验样 / 验样中</span>
                      <span class="status-blue" v-if="demand.demandStatus == 'wait_order'">待发起订单</span>
                      <span class="status-bidding" v-if="demand.demandStatus == 'bidding'">待竞价 / 竞价中</span>
                      <span class="status-blue" v-if="demand.demandStatus == 'completed'">已完成</span>
                      <span class="status-blue" v-if="demand.demandStatus == 'repurchase_bidding'">复购竞价</span>
                      <span class="status-bidding" v-if="demand.demandStatus == 'close'">关闭</span>
                    </div>
                    <span class="user-id">ID：{{ demand.userId }}</span>
                  </div>
                  <div class="role-text">{{ demand?.appUser?.postName || "无" }}</div>
                </div>
              </div>
              <div class="user-contact">
                <div class="contact-item">
                  <img style="width: 18px; height: 18px" src="@/assets/image/iconPhone.png" />
                  <span style="font-size: 18px">{{ demand?.appUser?.relationPhone || "无" }}</span>
                </div>
                <div class="contact-item">
                  <img style="width: 18px; height: 18px" src="@/assets/image/wechat.png" />
                  <span style="font-size: 18px">{{ demand?.appUser?.wxNumber || "无" }}</span>
                </div>
              </div>
            </div>
            <div class="time-row">
              <span>发布时间：{{ demand.releaseTime }}</span>
              <span class="divider">|</span>
              <span>验样截止时间：{{ demand.verifyEndTime }}</span>
            </div>
          </div>
        </div>

        <div style="background: #ffffff; border-radius: 16px; padding: 30px 22px; margin-top: 20px">
          <!-- 基本信息 -->
          <div>
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">基本信息</span>
            </div>
            <div style="margin-top: 24px">
              <div class="product-name">产品名称：{{ demand.productName }}</div>
              <div class="info-row" style="margin-top: 9px; display: block">
                <span class="label">产品分类：</span>
                <span class="value">{{ demand.productType }}</span>
                <div style="width: 1px; background: #999999; height: 12px; display: inline-block; margin-left: 10px"></div>
                <span class="label" style="margin-left: 10px">质量要求：</span>
                <span class="value">{{ demand.qualityDemand }}</span>
              </div>
              <div class="info-row remark-row">
                <span class="label">备注：</span>
                <span class="value">{{ demand.productRemark }}</span>
              </div>
            </div>
          </div>

          <!-- 图片 -->
          <div style="margin-top: 44px">
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">图片</span>
            </div>
            <div class="image-list" v-if="productPictureList.length != 0">
              <div v-for="(img, index) in productPictureList" :key="index" class="image-item">
                <el-image :src="img" :preview-src-list="productPictureList" fit="cover" />
              </div>
            </div>
            <div v-else>无</div>
          </div>

          <!-- 公司信息 -->
          <div style="margin-top: 24px">
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">公司信息</span>
            </div>
            <div style="margin-top: 10px">
              <div class="info-row">
                <span class="label">公司名称：</span>
                <span class="value">{{ demand?.appUser?.enterpriseName || "无" }}</span>
              </div>
              <div class="info-row" style="margin-top: 4px">
                <span class="label">公司地址：</span>
                <span class="value">{{ demand?.appUser?.address || "无" }}</span>
              </div>
              <div class="info-row" style="margin-top: 4px">
                <span class="label">E-mail：</span>
                <span class="value">{{ demand?.appUser?.mail || "无" }}</span>
              </div>
              <div class="license-row" style="margin-top: 4px">
                <span class="label">营业执照：</span>
                <template v-if="invoicePictureList.length > 0">
                  <el-image v-for="(item, index) in invoicePictureList" :preview-src-list="invoicePictureList" :key="index" class="license-img" :src="item"> </el-image>
                </template>
                <span v-else class="value">暂无</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 已申请验样人员 -->
        <div class="info-card" style="margin-top: 20px; border-radius: 20px">
          <div style="display: flex; align-items: center; justify-content: space-between">
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">已申请验样人员</span>
              <span class="title-count">（共{{ applyList.length }}个）</span>
            </div>
            <div v-show="applyList.length >= 1" style="font-size: 16px; color: #1869ff; cursor: pointer; user-select: none" @click="isShowMore = !isShowMore">{{ isShowMore ? "收起" : "展开" }}</div>
          </div>
          <div class="apply-list" v-if="applyList.length != 0" v-show="isShowMore">
            <div v-for="(item, index) in applyList" :key="index" class="apply-item">
              <span class="company-name">{{ item.enterpriseName }}</span>
              <span class="phone">
                <img style="width: 14px; height: 14px; margin-right: 5px" src="@/assets/image/iconPhone.png" />
                {{ item.relationPhone }}
              </span>
              <span class="apply-time">申请时间：{{ item.createTime }}</span>
            </div>
          </div>
          <div v-else>无</div>
        </div>
      </div>

      <!-- 底部申请按钮 -->
      <div class="footer-action">
        <el-button v-if="demand.demandStatus == 'bidding' && demand.bidding && isBiddingOpen" type="primary" class="btn-apply grey" @click="handleCloseBidding">取消竞价</el-button>
        <el-button v-if="demand.demandStatus == 'bidding' && demand.isAllowBidding && !demand.bidding && isBiddingOpen" type="primary" class="btn-apply" @click="openBiddingDialog">提交竞价</el-button>
        <el-button v-if="demand.demandStatus == 'bidding' && demand.bidding && demand.bidding.biddingStatus != 'pass' && isBiddingOpen" type="primary" class="btn-apply" @click="openBiddingDialog2">修改竞价</el-button>
        <el-button v-if="demand.demandStatus == 'release' && demand.applyVerify && demand.applyVerify.applyStatus != 'close'" type="primary" class="btn-apply grey" @click="openTerminateDialog"
          >终止</el-button
        >
        <!-- <el-button v-if="demand.demandStatus == 'release' && !demand.applyVerify" type="primary" class="btn-apply" @click="applyVer">申请验样</el-button> -->
        <!-- 供应商 搜索结果详情里 demandStatus =release, wait_order, bidding, repurchase_bidding -->
        <el-button v-if="demand.demandStatus == 'release' && !demand?.applyVerify" type="primary" class="btn-apply" @click="applyVer">申请验样</el-button>
        <el-button v-if="demand.demandStatus == 'wait_order' && !demand.applyVerify" type="primary" class="btn-apply" @click="applyVer">申请验样</el-button>
        <el-button v-if="demand.demandStatus == 'bidding' && !demand.applyVerify" type="primary" class="btn-apply" @click="applyVer">申请验样</el-button>
        <el-button v-if="demand.demandStatus == 'repurchase_bidding' && !demand.applyVerify" type="primary" class="btn-apply" @click="applyVer">申请验样</el-button>

        <el-button v-if="demand.demandStatus == 'repurchase_bidding' && demand.bidding && isBiddingOpen" type="primary" class="btn-apply grey" @click="handleCloseBidding">取消竞价</el-button>
        <el-button v-if="demand.demandStatus == 'repurchase_bidding' && demand.isAllowBidding && !demand.bidding && isBiddingOpen" type="primary" class="btn-apply" @click="openBiddingDialog">提交竞价</el-button>
        <el-button v-if="demand.demandStatus == 'repurchase_bidding' && demand.bidding && demand.bidding.biddingStatus != 'pass' && isBiddingOpen" type="primary" class="btn-apply" @click="openBiddingDialog2"
          >修改竞价</el-button
        >
      </div>
    </div>

    <!-- 提交成功结果弹窗 -->
    <ResultDialog :visible.sync="showResultDialog" title="提交成功" subtitle="请耐心等待采购方确认验样结果" @confirm="showResultDialog = false" @cancel="showResultDialog = false" />

    <!-- 终止招标确认弹窗 -->
    <ResultDialog
      :visible.sync="showTerminateDialog"
      title="终止提示"
      subtitle="你确定要终止验样申请吗？"
      :icon-src="require('@/assets/image/question-mark.png')"
      :dialog-width="'420px'"
      confirm-text="确定"
      cancel-text="取消"
      @confirm="handleTerminateConfirm"
      @cancel="showTerminateDialog = false"
      @close="closeTerminateDialog"
      btnMarginTop="35px"
    >
      <template #default>
        <div style="padding: 0 23px">
          <el-input resize="none" style="font-family: initial; font-size: 16px" type="textarea" :rows="6" placeholder="请输入终止理由" v-model="terminateReason"> </el-input>
        </div>
      </template>
    </ResultDialog>

    <!-- 产品需求发布弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showPublishDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="handleClosePublishDialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showPublishDialog = false" />
        <h3 class="publish-title">申请验样</h3>
        <div style="font-weight: 400; font-size: 16px; color: #999999; text-align: center">验样通过后即可参与竞价</div>
        <div class="publish-form">
          <div class="form-item">
            <span class="form-label">企业名称<i class="required-star">*</i></span>
            <el-input disabled v-model="publishForm.enterpriseName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系人<i class="required-star">*</i></span>
            <el-input v-model="publishForm.relationName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="publishForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">职务<i class="required-star">*</i></span>
            <el-input v-model="publishForm.postName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">微信号</span>
            <el-input v-model="publishForm.wxNumber" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">E-mail</span>
            <el-input v-model="publishForm.mail" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">地址<i class="required-star">*</i></span>
            <el-input v-model="publishForm.address" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注<i class="required-star">*</i></span>
            <el-input :maxlength="1000" show-word-limit v-model="publishForm.applyRemark" type="textarea" placeholder="请输入" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">公司营业执照<i class="required-star">*</i></span>
            <ImageUpload v-model="publishForm.businessLicense" :multiple="true" :limit="5" size="120px" dir="license" />
          </div>
        </div>

        <div style="text-align: center">
          <button class="publish-submit-btn" @click="applyVerifyFun">提交申请</button>
        </div>
      </div>
    </el-dialog>

    <!-- 提交竞价弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showBiddingDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="handleCloseBiddingDialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showBiddingDialog = false" />
        <h3 class="publish-title">提交竞价</h3>
        <div class="publish-form">
          <div class="form-item">
            <span class="form-label">产品名称<i class="required-star">*</i></span>
            <el-input v-model="biddingForm.productName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品类别<i class="required-star">*</i></span>
            <el-select v-model="biddingForm.productTypeId" placeholder="请选择" class="form-select" @change="productTypeIdChange">
              <!-- <el-option v-for="item in productTypes" :key="item.value" :label="item.label" :value="item.value" /> -->
              <el-option v-for="item in productTypeList" :key="item.productTypeId" :label="item.typeName" :value="item.productTypeId" />
            </el-select>
          </div>
          <div class="form-item">
            <span class="form-label">数量</span>
            <el-input type="number" v-model="biddingForm.number" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系人</span>
            <el-input v-model="biddingForm.relationName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="biddingForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">交货期限</span>
            <el-date-picker v-model="biddingForm.deliveryTime" type="date" placeholder="请选择" class="form-date" value-format="yyyy-MM-dd" />
          </div>
          <div class="form-item">
            <span class="form-label">付款方式</span>
            <el-input v-model="biddingForm.payMethod" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品质量</span>
            <el-input v-model="biddingForm.productQuality" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">单价<i class="required-star">*</i></span>
            <el-input type="number" v-model="biddingForm.price" placeholder="请输入单价" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">总价<i class="required-star">*</i></span>
            <el-input type="number" v-model="biddingForm.totalAmount" placeholder="请输入优惠总价" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">产品图片</span>
            <ImageUpload v-model="biddingForm.productPicture" :multiple="true" :limit="9" size="120px" dir="product" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">订单信息</span>
            <el-input v-model="biddingForm.orderInfo" type="textarea" placeholder="请输入订单信息" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注</span>
            <el-input :maxlength="1000" show-word-limit v-model="biddingForm.biddingRemark" type="textarea" placeholder="说点详细信息吧" class="form-textarea" :rows="4" />
          </div>
        </div>

        <div style="text-align: center">
          <button class="publish-submit-btn" @click="submitBidding">{{ isEditBiddingMode ? "修改竞价" : "提交竞价" }}</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopBanner from "@/components/TopBanner.vue";
import ResultDialog from "@/components/ResultDialog.vue";
import ImageUpload from "@/components/ImageUpload.vue";
import { resolveFileUrl } from "@/utils/oss";
import {
  getDemandDetail,
  applyVerify,
  getApplyVerifyList,
  getBiddingDetail,
  submitBidding as submitBiddingApi,
  editBidding,
  closeBidding,
  closeApplyVerify,
  getMyProductType,
} from "@/api/demand";
import { getDictData } from "@/api";

export default {
  name: "DemandDetail",
  components: {
    TopBanner,
    ResultDialog,
    ImageUpload,
  },
  data() {
    return {
      isShowMore: true,
      loading: false,
      showPublishDialog: false,
      showResultDialog: false,
      userRes: {},
      demand: {
        demandId: null,
        demandCode: "",
        userId: null,
        productName: "",
        productTypeId: "",
        productType: "",
        relationPhone: "",
        verifyEndTime: "",
        qualityDemand: "",
        productRemark: "",
        productPicture: "",
        invoicePicture: "",
        demandStatus: "",
        releaseTime: "",
        orderCount: 0,
        closeExplain: "",
        delFlag: 1,
        statusGroup: "",
        createBy: "",
        createTime: "",
        updateBy: "",
        updateTime: "",
        remark: "",
      },
      publishForm: {
        demandId: "", //需求id
        enterpriseName: "", //企业名称
        relationName: "", //联系人
        relationPhone: "", //联系电话
        postName: "", //职务名称
        wxNumber: "", //微信号
        mail: "", //邮箱
        address: "", //地址
        applyRemark: "", //申请备注
        businessLicense: [], //营业执照
      },
      applyList: [],
      // 终止招标弹窗
      showTerminateDialog: false,
      terminateReason: "",
      // 提交竞价弹窗
      showBiddingDialog: false,
      productTypes: [],
      biddingForm: {
        demandId: "",
        demandOrderId: "",
        productName: "",
        productTypeId: "",
        productType: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        price: "",
        totalAmount: "",
        productPicture: [],
        orderInfo: "",
        biddingRemark: "",
      },
      productTypeList: [],
    };
  },
  computed: {
    /** 竞价是否仍在进行中 */
    isBiddingOpen() {
      return (
        (this.demand.demandStatus === "bidding" || this.demand.demandStatus === "repurchase_bidding") &&
        this.demand.demandOrder &&
        this.demand.demandOrder.orderStatus === "bidding"
      );
    },
    /** 解析产品图片列表（逗号分隔） */
    productPictureList() {
      if (!this.demand.productPicture) return [];
      return this.demand.productPicture
        .split(",")
        .filter(Boolean)
        .map((u) => resolveFileUrl(u));
    },
    /** 解析发票/营业执照图片列表（逗号分隔） */
    invoicePictureList() {
      if (!this.demand?.appUser?.businessLicense) return [];
      return this.demand?.appUser?.businessLicense
        .split(",")
        .filter(Boolean)
        .map((u) => resolveFileUrl(u));
    },
    /** 是否为修改竞价模式 */
    isEditBiddingMode() {
      // return this.demand.demandStatus === "bidding" && this.biddingList.length !== 0;
      return this.demand.demandStatus === "bidding" && this.demand.bidding;
    },
  },
  watch: {
    "$route.params.id": {
      handler(newId) {
        if (newId) {
          this.fetchDemandDetail();
          this.fetchApplyVerifyList();
        }
      },
    },
  },
  mounted() {
    this.userRes = JSON.parse(localStorage.getItem("userRes"));
    this.publishForm.enterpriseName = this.userRes.enterpriseName || ""; //企业名称
    this.publishForm.relationName = this.userRes.relationName || "";
    this.publishForm.relationPhone = this.userRes.relationPhone || "";
    this.publishForm.postName = this.userRes.postName || "";
    this.publishForm.wxNumber = this.userRes.wxNumber || "";
    this.publishForm.mail = this.userRes.mail || "";
    this.publishForm.address = this.userRes.address || "";
    this.publishForm.businessLicense = Array.isArray(this.userRes.businessLicense) ? this.userRes.businessLicense.join(",") : this.userRes.businessLicense;

    this.fetchDemandDetail();
    this.fetchApplyVerifyList();
    // this.fetchDict();
    this.getProductTypeListFun();
  },
  methods: {
    productTypeIdChange(id) {
      this.productTypeList.forEach((item) => {
        if (item.productTypeId == id) {
          this.biddingForm.productType = item.typeName;
        }
      });
    },
    getProductTypeListFun() {
      getMyProductType().then((res) => {
        this.productTypeList = res.rows;
      });
    },
    /** 获取数据字典 */
    fetchDict() {
      getDictData("app_product_type").then((res) => {
        this.productTypes = (res.data || []).map((item) => ({
          label: item.dictLabel,
          value: item.dictValue,
        }));
      });
    },
    // 获取竞价详细信息
    openDetailInfo2() {
      const biddingId = this.demand.bidding.biddingId;
      getBiddingDetail(biddingId)
        .then((res) => {
          if (res.code == 200) {
            this.biddingForm.productName = res.data.productName;
            this.biddingForm.productTypeId = res.data.productTypeId;
            this.biddingForm.number = res.data.number;
            this.biddingForm.relationName = res.data.relationName;
            this.biddingForm.relationPhone = res.data.relationPhone;
            this.biddingForm.deliveryTime = res.data.deliveryTime;
            this.biddingForm.payMethod = res.data.payMethod;
            this.biddingForm.productQuality = res.data.productQuality;
            this.biddingForm.price = res.data.price;
            this.biddingForm.totalAmount = res.data.totalAmount;
            this.biddingForm.productPicture = res.data.productPicture ? String(res.data.productPicture).split(",").filter(Boolean) : [];
            this.biddingForm.orderInfo = res.data.orderInfo;
            this.biddingForm.biddingRemark = res.data.biddingRemark;
          } else {
            this.$message.error(res.msg || "获取竞价详情失败");
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取竞价详情失败");
        });
    },

    async applyVerifyFun() {
      // 必填字段校验
      const requiredFields = [
        { key: "enterpriseName", label: "企业名称" },
        { key: "relationName", label: "联系人" },
        { key: "relationPhone", label: "联系方式" },
        { key: "postName", label: "职务" },
        { key: "address", label: "地址" },
        { key: "applyRemark", label: "备注" },
      ];
      for (const field of requiredFields) {
        if (!this.publishForm[field.key] || !this.publishForm[field.key].trim()) {
          this.$message.warning(`请填写${field.label}`);
          return;
        }
      }
      if (!/^1[3-9]\d{9}$/.test(this.publishForm.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      // 公司营业执照校验（数组或字符串形式均兼容）
      const license = this.publishForm.businessLicense;
      const licenseEmpty = Array.isArray(license) ? license.length === 0 : !license || !String(license).trim();
      if (licenseEmpty) {
        this.$message.warning("请上传公司营业执照");
        return;
      }

      try {
        const params = {
          ...this.publishForm,
          businessLicense: Array.isArray(this.publishForm.businessLicense) ? this.publishForm.businessLicense.join(",") : this.publishForm.businessLicense,
        };
        const res = await applyVerify(params);
        if (res.code === 200) {
          this.showPublishDialog = false;
          this.showResultDialog = true;
          this.fetchDemandDetail();
          this.resetPublishForm();
          this.fetchApplyVerifyList();
        } else {
          this.$message.error(res.msg || "申请验样失败");
        }
      } catch (error) {
        console.error("申请验样失败：", error);
        this.$message.error(error.message || "申请验样失败");
      }
    },
    /** 获取需求详情 */
    async fetchDemandDetail() {
      const demandId = this.$route.params.id;
      if (!demandId) {
        this.$message.error("缺少需求ID参数");
        return;
      }
      this.loading = true;
      try {
        const res = await getDemandDetail(demandId);
        if (res && res.data) {
          this.demand = { ...this.demand, ...res.data };
          // console.log(this.demand, "asdasd");
        }
      } catch (error) {
        console.error("获取需求详情失败：", error);
        this.$message.error("获取需求详情失败");
      } finally {
        this.loading = false;
      }
    },
    /** 获取申请验样列表 */
    async fetchApplyVerifyList() {
      const demandId = this.$route.params.id;
      if (!demandId) return;
      try {
        const res = await getApplyVerifyList(demandId);
        if (res.code === 200) {
          this.applyList = res.rows;
        }
      } catch (error) {
        console.error("获取申请验样列表失败：", error);
      }
    },
    handleApply() {
      // this.$message.success("申请验样成功");
    },
    /** 打开终止招标弹窗 */
    openTerminateDialog() {
      this.terminateReason = "";
      this.showTerminateDialog = true;
    },
    /** 关闭终止招标弹窗 */
    closeTerminateDialog() {
      this.terminateReason = "";
    },
    /** 终止招标 - 确定 */
    async handleTerminateConfirm() {
      if (!this.terminateReason || !this.terminateReason.trim()) {
        this.$message.warning("请输入终止理由");
        return;
      }
      const applyVerifyId = this.demand?.applyVerify?.applyVerifyId;
      if (!applyVerifyId) {
        this.$message.error("未获取到申请验样ID");
        return;
      }
      try {
        const res = await closeApplyVerify({
          applyVerifyId,
          closeExplain: this.terminateReason,
        });
        if (res.code == 200) {
          this.showTerminateDialog = false;
          this.$message.success("已终止验样申请");
          this.fetchDemandDetail();
          this.fetchApplyVerifyList();
        } else {
          this.$message.error(res.msg || "操作失败");
        }
      } catch (error) {
        console.error("终止验样申请失败：", error);
        this.$message.error(error.message || "操作失败");
      }
    },
    applyVer() {
      this.publishForm.demandId = this.demand.demandId;
      this.showPublishDialog = true;
    },
    handleClosePublishDialog() {
      this.showPublishDialog = false;
      this.resetPublishForm();
    },
    resetPublishForm() {
      this.publishForm = {
        demandId: "", //需求id
        enterpriseName: this.userRes.enterpriseName, //企业名称
        relationName: this.userRes.relationName || "", //联系人
        relationPhone: this.userRes.relationPhone || "", //联系电话
        postName: this.userRes.postName || "", //职务名称
        wxNumber: this.userRes.wxNumber || "", //微信号
        mail: this.userRes.mail || "", //邮箱
        address: this.userRes.address || "", //地址
        applyRemark: "", //申请备注
        businessLicense: Array.isArray(this.userRes.businessLicense) ? this.userRes.businessLicense.join(",") : this.userRes.businessLicense, // 营业执照
      };
    },
    /** 打开修改竞价弹窗 */
    openBiddingDialog2() {
      this.biddingForm.demandId = this.demand.demandId;
      if (this.demand.biddingCount != "0") {
        this.openDetailInfo2(); // 获取竞价信息，数据回显表单
      }
      this.showBiddingDialog = true;
    },
    /** 打开提交竞价弹窗 */
    openBiddingDialog() {
      this.resetBiddingForm();
      this.biddingForm.demandId = this.demand.demandId;

      this.biddingForm.productName = this.demand.productName;
      this.biddingForm.productTypeId = this.demand.productTypeId;
      this.biddingForm.productType = this.demand.productType;
      this.biddingForm.relationName = this.userRes.relationName || "";
      this.biddingForm.relationPhone = this.userRes.relationPhone || "";
      this.showBiddingDialog = true;
    },
    /** 关闭提交竞价弹窗 */
    handleCloseBiddingDialog() {
      this.showBiddingDialog = false;
      this.resetBiddingForm();
    },
    /** 重置竞价表单 */
    resetBiddingForm() {
      this.biddingForm = {
        demandId: "",
        demandOrderId: "",
        productTypeId: "",
        productName: "",
        productType: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        price: "",
        totalAmount: "",
        productPicture: [],
        orderInfo: "",
        biddingRemark: "",
      };
    },
    /** 提交竞价 */
    async submitBidding() {
      // 必填校验
      if (!this.biddingForm.productName || !this.biddingForm.productName.trim()) {
        this.$message.warning("请填写产品名称");
        return;
      }
      if (!this.biddingForm.productTypeId) {
        this.$message.warning("请选择产品类别");
        return;
      }
      if (!this.biddingForm.relationPhone || !this.biddingForm.relationPhone.trim()) {
        this.$message.warning("请填写联系方式");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.biddingForm.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!this.biddingForm.price) {
        this.$message.warning("请填写单价");
        return;
      }
      if (!this.biddingForm.totalAmount || !this.biddingForm.totalAmount.trim()) {
        this.$message.warning("请填写总价");
        return;
      }
      const isEdit = this.isEditBiddingMode;
      try {
        // 构建请求参数，多图转为逗号分隔字符串
        const params = {
          ...this.biddingForm,
          demandOrderId: this.demand.demandOrder.demandOrderId,
          serialNumber: this.demand.demandOrder.serialNumber,
          productPicture: Array.isArray(this.biddingForm.productPicture) ? this.biddingForm.productPicture.join(",") : this.biddingForm.productPicture,
        };
        // 修改模式需要传 biddingId
        if (isEdit) {
          params.biddingId = this.demand.bidding.biddingId;
        }
        const res = isEdit ? await editBidding(params) : await submitBiddingApi(params);
        if (res.code == 200) {
          this.showBiddingDialog = false;
          this.$message.success(isEdit ? "修改竞价成功" : "提交竞价成功");
          this.resetBiddingForm();
          this.fetchDemandDetail();
          this.fetchApplyVerifyList();
        } else {
          this.$message.error(res.msg || (isEdit ? "修改竞价失败" : "提交竞价失败"));
        }
      } catch (error) {
        console.error(isEdit ? "修改竞价失败：" : "提交竞价失败：", error);
        this.$message.error(error.message || (isEdit ? "修改竞价失败" : "提交竞价失败"));
      }
    },
    /** 取消竞价 */
    handleCloseBidding() {
      console.log(this.demand.bidding, "this.demand.bidding.biddingIdthis.demand.bidding.biddingIdthis.demand.bidding.biddingId");
      this.$confirm("确定要取消竞价吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const biddingId = this.demand.bidding.biddingId;
            const res = await closeBidding({
              biddingId: biddingId,
              closeExplain: "关闭了",
            });
            if (res.code == 200) {
              this.$message.success("取消竞价成功");
              this.fetchDemandDetail();
              this.fetchApplyVerifyList();
            } else {
              this.$message.error(res.msg || "取消竞价失败");
            }
          } catch (error) {
            console.error("取消竞价失败：", error);
            this.$message.error(error.message || "取消竞价失败");
          }
        })
        .catch(() => {
          // 用户取消操作
        });
    },
  },
};
</script>

<style>
/* 引入产品需求发布弹窗公共样式 */
@import "~@/assets/css/publish-dialog.css";
</style>

<style scoped>
.demand-detail-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f0f4fa;
}

.demand-scroll-area {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.page-content {
  max-width: 1200px;
  margin: 0 auto;
}

/* 信息卡片 */
.info-card {
  background: #ffffff;
  padding: 22px 24px;
}

/* 用户信息卡片 */
.user-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-main {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.status-tag {
  display: inline-block;
  border-radius: 4px;
  font-size: 12px;
}
.status-tag .status-valid {
  padding: 4px 8px;
  background: rgba(0, 166, 62, 0.1);
  color: #00a63e;
  border-radius: 4px;
}
.status-tag .status-bidding {
  padding: 2px 8px;
  background: rgba(235, 82, 0, 0.1);
  color: #ff0000;
  border-radius: 4px;
}
.status-tag .status-blue {
  padding: 2px 8px;
  background: #e3edff;
  color: #1869ff;
  border-radius: 4px;
}

.user-id {
  font-size: 12px;
  color: #999;
}

.role-text {
  font-size: 12px;
  color: #999;
}

.time-row {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.time-row .divider {
  margin: 0 8px;
}

.user-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  color: #333;
}

/* 区块标题 */
.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
}

.title-bar {
  display: inline-block;
  width: 6px;
  height: 22px;
  background: #1869ff;
  border-radius: 3px;
}

.title-text {
  font-size: 24px;
  font-weight: 500;
  color: #333;
}

.title-count {
  font-size: 16px;
  color: #999;
  font-weight: 400;
}

.product-name {
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  color: #666;
}

.info-row .label {
  color: #999;
  flex-shrink: 0;
}

.info-row .value {
  color: #333;
}

.remark-row {
  margin-top: 4px;
}

.remark-row .value {
  line-height: 1.6;
}

/* 图片列表 */
.image-list {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}

.image-item {
  width: 134px;
  height: 134px;
  border-radius: 8px;
  overflow: hidden;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.license-row {
  display: flex;
  align-items: flex-start;
}

.license-row .label {
  color: #999;
  font-size: 14px;
  flex-shrink: 0;
}

.license-img {
  width: 280px;
  height: 200px;
  border-radius: 10px;
  margin-right: 8px;
}

/* 申请列表 */
.apply-list {
  padding-left: 12px;
  margin-top: 7px;
}

.apply-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0 10px 0;
  border-bottom: 1px solid #efefef;
  font-size: 16px;
}

.apply-item .company-name {
  color: #999;
  flex: 1;
}

.apply-item .phone {
  color: #999;
  flex: 1;
  display: flex;
  align-items: center;
}

.apply-item .apply-time {
  color: #999;
  flex: 1;
  text-align: right;
}

/* 底部操作 */
.footer-action {
  gap: 28px;
  padding: 56px 0 40px 0;
  display: flex;
  justify-content: center;
}

.btn-apply {
  width: 270px;
  height: 48px;
  background: #1869ff;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  color: #fff;
  margin: 0;
}

.btn-apply.grey {
  background: #e2e2e2;
  color: #333333;
}
/deep/ .el-textarea__inner {
  font-family: initial !important;
  border-radius: 14px;
}
</style>
